
// Make Alpine 3 support legacy browsers
if (typeof window.queueMicrotask !== "function") {
    window.queueMicrotask = function (callback) {
      Promise.resolve()
        .then(callback)
        .catch(e => setTimeout(() => { throw e; }));
    };
}
//





document.addEventListener('alpine:init', () => {
      Alpine.store('dropdown', false);
        Alpine.store('clicked_test', false)

        Alpine.effect(() => {
          var dropdown = Alpine.store('dropdown')
            var test = Alpine.store('dropdown')
          if (dropdown === true) {
            console.log('dropdown true')
            document.body.classList.add("S-has--dropdown")
          }
          else {
                  console.log('dropdown false')

            document.body.classList.remove("S-has--dropdown")


          }
              console.log('dropdown')
         console.log(Alpine.store('dropdown'))
                     console.log('clicktest')
            console.log(Alpine.store('clicked_test'))

     })
  })







///////TEMPALTE WRAP STARTS//////////
if (document.body.classList.contains('page-template-etusivu')) {
console.log("home HELLO");
 }


window.swiper_css_mode = false;

 if (window.innerWidth > 1101) {
     console.log("larger Screen");
 }
 else {
      console.log("Small Screen");
      // swiper_css_mode = true;
 }




 function initSwiper() {

console.log("init swiper");

     this.mySwiper = new Swiper(".swiper-container", {

   // Optional parameters

	 slidesPerView: "auto",
	        spaceBetween: 0,
					grabCursor: true,
            cssMode: swiper_css_mode,


   // Navigation arrows
   navigation: {
     nextEl: '.swiper-button-next.-bike-swiper',
     prevEl: '.swiper-button-prev.-bike-swiper',
   },

   // And if we need scrollbar
   scrollbar: {
     el: '.swiper-scrollbar.-bike-swiper',
		 draggable: true,
   },
 });


}

 // const swiper_quotes = new Swiper('.swiper-quotes', {
	//  // Optional parameters
 //
	// slidesPerView: "auto",
	// 			 spaceBetween: 0,
	// 			 			grabCursor: true,
 //              cssMode: swiper_css_mode,
 //
 //
 //
	//  // Navigation arrows
	//  navigation: {
	// 	 nextEl: '.swiper-button-next.-quote-swiper',
	// 	 prevEl: '.swiper-button-prev.-quote-swiper',
	//  },
 //
	//  // And if we need scrollbar
	//  scrollbar: {
	// 	 el: '.swiper-scrollbar.-quote-swiper',
	// 	draggable: true,
	//  },
 // });



// window.runEventFiltered = function(event) {
//   event.preventDefault();
// var the_url = event.currentTarget.href;
//       document.querySelector('body').classList.add("S--has-event-filters");
//
//   }
//   window.runEventsAll = function(event) {
//     event.preventDefault();
//   var the_url = event.currentTarget.href;
//         document.querySelector('body').classList.remove("S--has-event-filters");
//
//     }




 window.initPjaxLinks = function(event) {
   if (document.querySelector(".pjax-group-nav"))  {
     console.log("has group nav");
   }
    var nav_elems = document.querySelectorAll('.pjax-link');
   nav_elems.forEach(function (elem) {
     // console.log(elem);
      if (elem.dataset.pjax.includes(current_url)) {
        elem.classList.add("active-pjax");
        }
        else  {

        }
   });

   }
// initPjaxLinks();


window.onpopstate = history.onpushstate = function(e)
    {
    location.reload()
    };


window.runPjax = function(event) {
  event.preventDefault();



  if (document.body.classList.contains("S-on-sticky-scroll")) {
    console.log("on sitcky");
    document.querySelector(".scroll-target").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

  }



var the_url = event.currentTarget.href;
event.currentTarget.classList.add("prevent-click");
setTimeout(function() {
                    document.querySelector('.prevent-click').classList.remove("prevent-click");
                    console.log("link active again");
                }, 200);
                document.querySelector('body').classList.add("pjax-loading")
                var the_url = event.currentTarget.href;
                               var stateObj;
                               var pjax_url = the_url;
                               window.history.pushState(stateObj, "", the_url);

event.currentTarget.classList.add("S-active");


   var nav_elems = document.querySelectorAll('.btn--filter');
  nav_elems.forEach(function (elem) {

           elem.classList.remove("S-active");

  });
event.currentTarget.classList.add("S-active");


               axios.get(the_url).then(function(response) {

                      var parent_container = document.querySelector('.pjax-wrap');
                      var wrapper = document.createElement('div');
                      wrapper.innerHTML = response.data;
                      var newContent = wrapper.querySelector('.pjax-container');
                      setTimeout(function() {
                        var oldContent = document.querySelector('.pjax-container');
                                    if (oldContent !== null) {
                                        oldContent.parentNode.removeChild(oldContent);
                                    }
                          parent_container.appendChild(newContent);





                          setTimeout(function() {
                                document.querySelector('body').classList.remove("pjax-loading")


                          }, 200);
                      }, 300);
                  }).catch(function(error) {
                      console.log(error);
                      window.location.reload();
                  }).then(function() {});
                  return false;


  // nav_elems.forEach(function (elem) {
  //   // console.log(elem);
  //    if (elem.dataset.pjax.includes(current_url)) {
  //      elem.classList.add("active-pjax");
  //      }
  //      else  {
  //
  //      }
  // });

  }

  window.showMore = function(e) {
document.querySelector(".posts-more-container").classList.remove("posts-more-container--hidden");
document.querySelector("#load-more").style.display = "none";

                 }


  window.runTaxFilters_tyot = function(e) {


    if (document.body.classList.contains("S-on-sticky-scroll")) {
      console.log("on sitcky");
      document.querySelector(".scroll-target").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

    }

                                   let targets_area = e.target.getAttribute('data-tax');
                                   console.log(targets_area);
                                      var tax_elems = document.querySelectorAll('.cell--tyot-card');
                                      document.body.classList.add("S-animating--filters");
                                      if (document.querySelector(".btn--filter.S-active")) {
                                         document.querySelector(".btn--filter.S-active").classList.remove("S-active");
                                      }

                                      setTimeout(function(){
                                        e.target.classList.add("S-active");

                                      }, 0);
                                        setTimeout(function(){
                                      tax_elems.forEach(function (elem) {
                                        console.log(elem);
                                         if (elem.dataset.tax.includes(targets_area)) {
                                           elem.classList.remove("S-disabled__item");
                                           }
                                           else  {
                                             elem.classList.add("S-disabled__item");
                                           }
                                      });
                                               document.body.classList.remove("S-animating--filters");
                                           }, 300);



                                 }


                                 window.resetTaxFilters_tyot = function(e) {


                                                     var tax_elems = document.querySelectorAll('.cell--tyot-card');
                                                     document.body.classList.add("S-animating--filters");
                                                     if (document.querySelector(".btn--filter.S-active")) {
                                                        document.querySelector(".btn--filter.S-active").classList.remove("S-active");
                                                     }

                                                       setTimeout(function(){
                                                     tax_elems.forEach(function (elem) {
                                                             elem.classList.remove("S-disabled__item");
                                                     });
                                                              document.body.classList.remove("S-animating--filters");
                                                          }, 300);
                                                }






//////STICKY STUFFFFFF///////

  // get the sticky element





  if   (document.querySelector(".page-template-etusivu")) {
        var stickyElm = document.querySelector('.home-featured-article');
  }
else {
    var stickyElm = document.querySelector('.sticky-nav--target');
}

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {

    if (entry.isIntersecting) {
       document.body.classList.toggle('S-has-sticky-container');
    }
    else {
        document.body.classList.toggle('S-has-sticky-container');
    }

  })
})
if (stickyElm) {
observer.observe(stickyElm)
}

if (stickyElm) {
  // get the first parent element which is scrollable
  const stickyElmScrollableParent = getScrollParent(stickyElm);

  // save the original offsetTop. when this changes, it means stickiness has begun.
  stickyElm._originalOffsetTop = stickyElm.offsetTop;


  // compare previous scrollTop to current one
  const detectStickiness = (elm, cb) => () => cb & cb(elm.offsetTop != elm._originalOffsetTop)

  // Act if sticky or not
  const onSticky = isSticky => {
     // console.clear()
     console.log(isSticky)

     stickyElm.classList.toggle('isSticky', isSticky)
  	 document.body.classList.toggle('S-on-sticky-scroll', isSticky)
  }

  // bind a scroll event listener on the scrollable parent (whatever it is)
  // in this exmaple I am throttling the "scroll" event for performance reasons.
  // I also use functional composition to diffrentiate between the detection function and
  // the function which acts uppon the detected information (stickiness)

  const scrollCallback = throttle(detectStickiness(stickyElm, onSticky), 100)
  stickyElmScrollableParent.addEventListener('scroll', scrollCallback)





  // OPTIONAL CODE BELOW ///////////////////

  // find-first-scrollable-parent
  // Credit: https://stackoverflow.com/a/42543908/104380
  function getScrollParent(element, includeHidden) {
      var style = getComputedStyle(element),
          excludeStaticParent = style.position === "absolute",
          overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

      if (style.position !== "fixed")
        for (var parent = element; (parent = parent.parentElement); ){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === "static")
                continue;
            if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX))
              return parent;
        }

      return window
  }

  // Throttle
  // Credit: https://jsfiddle.net/jonathansampson/m7G64
  function throttle (callback, limit) {
      var wait = false;                  // Initially, we're not waiting
      return function () {               // We return a throttled function
          if (!wait) {                   // If we're not waiting
              callback.call();           // Execute users function
              wait = true;               // Prevent future invocations
              setTimeout(function () {   // After a period of time
                  wait = false;          // And allow future invocations
              }, limit);
          }
      }
  }

  }


////////////////// WRAPPER CODE FOR PJAX ////


function init_common_js() {

const the_animation = document.querySelectorAll('.animation-element')

const observer_animation = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('scroll-animation');
            setTimeout(function() {
            entry.target.classList.add('scroll-animation--lets-click');
          }, 1000);

        }
            else {

            }

    })
},
   { threshold: 0.4
   });
//
  for (let i = 0; i < the_animation.length; i++) {
   const elements = the_animation[i];

    observer_animation.observe(elements);
  }





  var target = document.querySelectorAll(".module--super-text h1");
              for (var i = 0, len = target.length; i < len; i++) {
                  var target_i = target[i];
                  var text = new SplitType(target_i,{
                      types: 'words'
                  });
              }


              var target_ = document.querySelectorAll(".module--super-text h2");
                          for (var i = 0, len = target_.length; i < len; i++) {
                              var target_i = target_[i];
                              var text = new SplitType(target_i,{
                                  types: 'words'
                              });
                          }
                          var target_ = document.querySelectorAll(".module--super-text h3");
                                      for (var i = 0, len = target_.length; i < len; i++) {
                                          var target_i = target_[i];
                                          var text = new SplitType(target_i,{
                                              types: 'words'
                                          });
                                      }




    }


    // run once when page loads
if (document.readyState === 'complete') {
  init_common_js();
} else {
  document.addEventListener('DOMContentLoaded', () => init_common_js());
}




  /////SWUP////


//   if (document.body.classList.contains("page-template-tiimi")) {
//   const options = {
//     linkSelector:
//       '.swup-link',
// };
//
// const swup = new Swup(options);
//
//
// swup.on('contentReplaced', () => {
//   swup.options.containers.forEach((selector) => {
//     // window.scrollTo(0, 0)
//
//   });
// });
// // run after every additional navigation by swup
// swup.on('contentReplaced', init_common_js);
// }

   window.runVimeo = function(e) {

      let da_video = e.target.closest('.module--film-with-cover').querySelector("iframe");

      console.log(da_video);

      let iframe = da_video;
      let player = new Vimeo.Player(iframe);
      player.play();
    };



window.runModal = function(event) {
         event.preventDefault();
         // Use event.target to get the value of data-txt attribute
          let dataTxtColor = event.currentTarget.getAttribute('data-txt');

          // Log the obtained data-txt value to console for debugging
          console.log('data-txt value:', dataTxtColor);

          // Update CSS variable using the obtained value
          var r = document.querySelector(':root');
          r.style.setProperty('--main-txt-color', dataTxtColor);

          let dataBGColor = event.currentTarget.getAttribute('data-bg');

          // Log the obtained data-txt value to console for debugging
          console.log('data-txt value:', dataBGColor);

          // Update CSS variable using the obtained value
          var r = document.querySelector(':root');
          r.style.setProperty('--main-bg-color', dataBGColor);

          // Log to console for debugging
          console.log('CSS variable updated');
    console.log("modal run");
    event.currentTarget.classList.add("prevent-click");
       let targets_area = event.target.getAttribute('data-modal');
             var tax_elems = document.querySelectorAll('.modal-item');
      var root = document.getElementsByTagName("HTML")[0];

      root.classList.add("S-has--modal")
        root.classList.add("modal-transitioning")
      var the_url = event.currentTarget.href;
      // console.log(the_url);
      var stateObj;
      window.history.pushState(stateObj, "", the_url);

      document.querySelector(".modal-smoke").classList.remove("S-hidden");
      document.querySelector(".modal").classList.remove("S-hidden");


      var oldContent = document.querySelector('.pjax-container--main');
    if (oldContent !== null) {
      oldContent.parentNode.removeChild(oldContent);
    }

window.gBodyScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  document.querySelector('.pjax-view').removeAttribute("style");

  // Make a request for a user with a given ID
  axios.get(the_url)
    .then(function (response) {
      // handle success

      // console.log(response.data);
      var film_container = document.querySelector('.pjax-view');


        var wrapper = document.createElement('div');
            wrapper.innerHTML = response.data;
            var newContent = wrapper.querySelector('.pjax-container--main');
            film_container.appendChild(newContent);
              setTimeout(function(){
                initModalcode();
                // document.querySelector('.main-app').style.opacity = "0";
                // document.querySelector('.main-navigation--wrapper').style.visibility = "hidden";
                // root.classList.add("body-bg-override");
                setTimeout(function(){
                    document.querySelector('.modal-smoke').style.display = "none";
              document.querySelector('.site-container').style.display = "none";
              document.querySelector('.pjax-view').style.display = "block";

              root.classList.add("overlay-view--active");
                  root.classList.remove("modal-transitioning");
            }, 0);
              window.scrollTo(0, 0);



              // document.querySelector('.prevent-click').classList.remove("prevent-click");
              //   var next_film_link = document.querySelector(".js-next-film-link");
              //   if(typeof(next_film_link) != 'undefined' && next_film_link != null){
              //     next_film_trigger();
              //   } else{
              //     // console.log("no next film");
              //   }

                // document.querySelector('.film-loading-wrapper').style.opacity = "0";
                setTimeout(function(){
             //      document.querySelector('.film-loading-wrapper').style.display = "none";
             //      var root = document.getElementsByTagName("HTML")[0];
             //      document.querySelector('.close-fim-button').style.opacity = "1";
             //      document.querySelector('.pjax-container--main').removeAttribute("style");
             //
             // document.querySelector('.pjax-container--film').classList.remove("film--hidden");



           }, 0);
         }, 0);


    })
    .catch(function (error) {
      // handle error
      console.log(error);
    })
    .then(function () {
      // console.log("axios request");

    });
   }




function initModalcode() {


 function wrap(el, wrapper) {
      if (wrapper===undefined) {
         wrapper = document.createElement('div')
      }
      el.parentNode.insertBefore(wrapper, el)
      wrapper.appendChild(el)
      return wrapper
   }
   	document.querySelectorAll('iframe[src*="youtube.com"], iframe[data-src*="youtube.com"], iframe[src*="vimeo.com"], iframe[data-src*="vimeo.com"]').forEach(iframe =>{
   		if(! iframe.parentElement.classList.contains('videowrapper')){
   			wrap(iframe).classList.add('videowrapper');
   		}
   	});
}



   window.hideModal = function(e) {
                event.preventDefault();




  document.querySelector('.pjax-container--main').style.opacity = "0";

                  setTimeout(function(){

    var root = document.getElementsByTagName("HTML")[0];
    root.classList.remove("S-has--modal")
        root.classList.add("keep-nav-hidden");
        setTimeout(function(){
          root.classList.remove("keep-nav-hidden");
    }, 750);
    root.classList.remove("overlay-view--active");
                 document.querySelector('.site-container').style.display = "block";
                 document.querySelector('.pjax-view').style.display = "none";
             document.querySelector(".modal-smoke").classList.add("S-hidden");
             document.querySelector(".modal").classList.add("S-hidden");
               window.scrollTo(0, gBodyScroll);

           }, 0);
             //   document.querySelector('.modal-smoke').style.display = "block";



                // document.querySelector(".modal-smoke").classList.add("S-hidden");
                // document.querySelector(".modal").classList.add("S-hidden");

                // document.querySelector(".modal").scroll(0,0);

                var the_url = current_url;
                                       var stateObj;
                                       var pjax_url = the_url;
                                       window.history.pushState(stateObj, "", the_url);

            }





///CHECK GRIDHOME
if (document.querySelector('.js--grid')) {

            function init_grid_view() {


              console.log("GRID_INIT");

            //   setTimeout(function() {
            //         var root = document.getElementsByTagName("HTML")[0];
            //   root.classList.add("filters-active");
            // }, 800);

              var elem = document.querySelector('.js--grid');
              window.msnry = new Masonry(elem, {
                // options
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                percentPosition: true,
                transitionDuration: 0
              });

              // msnry.layout();

            }

            init_grid_view();


            window.addEventListener('resize', resize_update);


            function resize_update() {

              // init_gsap();
              msnry.layout();
            }

            /////Image loading ////

            // imagesLoaded( document.querySelector('.logo-image'), function( instance ) {
            // console.log('all images are loaded --logo-image');
            //   setTimeout(function(){
            // // document.querySelector('.main-app').classList.remove("--loading");
            //     }, 100);
            // });

            imagesLoaded( document.querySelector('.js--grid'), function( instance ) {
            console.log('all images are loaded --grid');


              deferImages();
            document.querySelector('.js--grid').classList.remove("grid--loading");

                msnry.layout();

                setTimeout(function(){

                }, 100);




            });



            function deferImages(){
              // get all images with 'deferload' class
              var $images = document.querySelectorAll("img.--full-size");

              // if there are images on the page run through each and update src
              if($images.length > 0) {
                for (var i = 0, len = $images.length; i < len; i++) {

                  // get url from each image
                  var image_url = $images[i].getAttribute("data-src");
                  // set image src

                  $images[i].onload = function(e) {
                    e.target.style.opacity = 1;
                      e.target.style.transform = "none";
                        e.target.parentElement.classList.add("image-is-loaded");
                // console.log(e);
                  };
                  $images[i].onerror = function() {
                    // console.log("noload");
                  };
                  $images[i].src = image_url;


                  // debugging
                  var $lognumber = i + 1;
                  // console.log("Image No." + $lognumber + " loaded");
                }
              }
              // console.log("Images loaded")
            }

        }





          window.closeContact = function (e) {
                var root = document.getElementsByTagName("HTML")[0];
        	root.classList.add("S--contact-not-active")
        }

        window.showContact = function (e) {
              var root = document.getElementsByTagName("HTML")[0];
        root.classList.remove("S--contact-not-active")
      }






        window.runTaxFilters_work = function(e) {
                                        console.log("tax run");
                                         let targets_area = e.target.getAttribute('data-tax');
                                         document.querySelector(".sidebar__tags-wrap").classList.remove("keep-open");
                                         var scrollPositionNotTop = window.scrollY || window.pageYOffset;

                                         if (scrollPositionNotTop > 800) {
                                           window.scrollTo({
                                             top: 0,
                                             behavior: 'smooth'
                                           });
                                         } else {

                                         }

                                            var tax_elems = document.querySelectorAll('.grid-item');
                                            var tax_groups = document.querySelectorAll(".tag-group");
                                            var tax_filters = document.querySelectorAll('.tag-group__button');
                                            document.body.classList.add("S-animating--filters");

                                            if (e.target.classList.contains('btn--basic')) {
                                            if (document.querySelector(".btn--basic.S-active")) {
                                               document.querySelector(".btn--basic.S-active").classList.remove("S-active");
                                            }
                                              }

                                            tax_filters.forEach(function (elem) {
                                              elem.classList.remove("S-active");

                                            });

                                            setTimeout(function(){
                                              e.target.classList.add("S-active");

                                            }, 0);
                                              setTimeout(function(){
                                            tax_elems.forEach(function (elem) {

                                               if (elem.dataset.tax.includes(targets_area)) {
                                                 elem.classList.remove("S-disabled__item");
                                                 }
                                                 else  {
                                                   elem.classList.add("S-disabled__item");
                                                 }
                                            });
                                            tax_groups.forEach(function (elem) {

                                               if (elem.dataset.tax.includes(targets_area)) {
                                                 elem.classList.remove("S-disabled__item");
                                                 }
                                                 else  {
                                                   elem.classList.add("S-disabled__item");
                                                 }
                                            });
                                              setTimeout(function(){
                                                msnry.layout();
                                                setTimeout(function(){
                                                document.body.classList.remove("S-animating--filters");
                                                }, 100);
                                              }, 100);

                                                 }, 300);





                                       }


                                       window.runTaxFilters_topics = function(e) {
                                                                       console.log("tax run filters");
                                                                        let targets_area = e.target.getAttribute('data-filter');
                                                                        document.querySelector(".sidebar__tags-wrap").classList.add("keep-open");
                                                                        var scrollPositionNotTop = window.scrollY || window.pageYOffset;

                                                                        if (scrollPositionNotTop > 800) {
                                                                          window.scrollTo({
                                                                            top: 0,
                                                                            behavior: 'smooth'
                                                                          });
                                                                        } else {

                                                                        }

                                                                           var tax_elems = document.querySelectorAll('.grid-item');
                                                                           var tax_filters = document.querySelectorAll('.tag-group__button');
                                                                           document.body.classList.add("S-animating--filters");
                                                                           // if (document.querySelector(".btn--basic.S-active")) {
                                                                           //    document.querySelector(".btn--basic.S-active").classList.remove("S-active");
                                                                           // }
                                                                           tax_filters.forEach(function (elem) {
                                                                             elem.classList.remove("S-active");

                                                                           });

                                                                           setTimeout(function(){
                                                                             e.target.classList.add("S-active");

                                                                           }, 0);
                                                                             setTimeout(function(){
                                                                           tax_elems.forEach(function (elem) {

                                                                              if (elem.dataset.filter.includes(targets_area)) {
                                                                                elem.classList.remove("S-disabled__item");
                                                                                }
                                                                                else  {
                                                                                  elem.classList.add("S-disabled__item");
                                                                                }
                                                                           });

                                                                             setTimeout(function(){
                                                                               msnry.layout();
                                                                               setTimeout(function(){
                                                                               document.body.classList.remove("S-animating--filters");
                                                                               }, 100);
                                                                             }, 100);

                                                                                }, 300);





                                                                      }


                                       window.resetTaxFilters_work = function(e) {
                                         document.querySelector(".sidebar__tags-wrap").classList.remove("keep-open");
                                         var scrollPositionNotTop = window.scrollY || window.pageYOffset;

                                         if (scrollPositionNotTop > 160) {
                                           window.scrollTo({
                                             top: 0,
                                             behavior: 'smooth'
                                           });
                                         } else {

                                         }

                                                  var tax_groups = document.querySelectorAll(".tag-group");

                                                  tax_groups.forEach(function (elem) {

                                                       elem.classList.add("S-disabled__item");

                                                  });


                                                           var tax_elems = document.querySelectorAll('.grid-item');
                                                           document.body.classList.add("S-animating--filters");
                                                           if (document.querySelector(".btn--basic.S-active")) {
                                                              document.querySelector(".btn--basic.S-active").classList.remove("S-active");
                                                           }

                                                             setTimeout(function(){
                                                           tax_elems.forEach(function (elem) {
                                                                   elem.classList.remove("S-disabled__item");
                                                           });
                                                           setTimeout(function(){
                                                             msnry.layout();
                                                             setTimeout(function(){
                                                             document.body.classList.remove("S-animating--filters");
                                                             }, 100);
                                                           }, 100);
                                                                }, 300);
                                                      }
